import api from "./api";

// Busca o questionário ativo com respostas do usuário logado
// Endpoint: GET /api/questionarioResposta/getAtivoByLoggedUser
export const getRespostaAtivaByLoggedUser = () =>
  api.get("/api/questionarioResposta/getAtivoByLoggedUser");

// Busca o histórico de ações relacionado ao questionário
// Endpoint: GET /api/questionarioResposta/getHistoricoAcaoQuestionario/{id}
export const getHistoricoAcaoQuestionario = (id) =>
  api.get(`/api/questionarioResposta/getHistoricoAcaoQuestionario/${id}`);

// Salva a resposta do questionário com JSON e arquivos em multipart/form-data
// Endpoint: PUT /api/questionarioResposta/salvar/{id}
export const salvarRespostaComArquivos = (
  id,
  json,
  receitaOperacional,
  arquivos = [],
) => {
  const formData = new FormData();

  var dadosCadastros = {
    ResponsavelPreenchimento: localStorage.getItem("responsavelQuestionaro"),
    CargoResponsavel: localStorage.getItem("cargoResponsavel"),
  };

  if (json.json) {
    json = json.json;
    formData.append("json", json);
  } else {
    formData.append("json", JSON.stringify(json));
  }

  formData.append("ReceitaOperacional", receitaOperacional?.toString() ?? "0");

  for (const chave in dadosCadastros) {
    if (dadosCadastros[chave] !== "") {
      formData.append(chave, dadosCadastros[chave]);
    }
  }

  arquivos.forEach((file) => {
    formData.append("arquivos", file);
  });

  return api.put(`/api/questionarioResposta/salvar/${id}`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

// Envia a resposta final do questionário com os campos obrigatórios e arquivos
// Endpoint: PUT /api/questionarioResposta/enviar/{id}
export const enviarRespostaFinal = (
  id,
  {
    json,
    responsavelPreenchimento,
    cargoResponsavel,
    receitaOperacional,
    percentualConclusao,
    arquivos = [],
  },
) => {
  const formData = new FormData();
  formData.append("json", JSON.stringify(json));
  formData.append("ResponsavelPreenchimento", responsavelPreenchimento);
  formData.append("CargoResponsavel", cargoResponsavel);
  formData.append("ReceitaOperacional", receitaOperacional);
  formData.append("PercentualConclusao", percentualConclusao);
  arquivos.forEach((file) => {
    formData.append("Arquivos", file);
  });

  return api.put(`/api/questionarioResposta/enviar/${id}`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

// Busca a resposta ativa do questionário por ID
// Endpoint: GET /api/questionarioResposta/getAtivoById/{id}
export const getQuestionarioRespostaById = (id) =>
  api.get(`/api/questionarioResposta/getAtivoById/${id}`);
